import React, { useCallback, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Box, Button, Menu, ResponsiveContext, Text } from 'grommet';
import { Menu as MenuIcon } from 'grommet-icons'
import adapter from '@flopflip/memory-adapter';
import { ToggleFeature, ConfigureFlopFlip } from '@flopflip/react-broadcast';
import { css } from 'styled-components'
import { Anchor, Grommet } from 'grommet'
import SignInOutButton from 'components/common/SignInOutButton'
import * as ROUTES from 'components/common/Routes'
import flags from 'components/common/flopflip-flags'
import { AuthorizedUserContext } from 'components/common/AuthorizedUser'

// TODO: Consider to use GrommetThemeExtender or styled-components
const ButtonLabel = (props) => (
    <span style={{whiteSpace: 'nowrap'}}>
        {props.children}
    </span>
)


const PayPalSubscribeButton = () => {
    return (
        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="CSJRY6WC7JRD4" />
        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribeCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!" />
        <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
        </form>
    )
}



const TwoLineSelectable = (props) => {
    const handleClick = useCallback((e) => { 
        e.preventDefault()
        let { route, history } = props;
        switch (route) {
          case '/':
            return history.push(ROUTES.LANDING)
            break;
          /*
          case '/partners':
            return history.push(ROUTES.PARTNERS)
            break;
          */
          default:
            return null; 
        } 
    })

    return <Box onClick={handleClick} direction='column'> 
        <Text color='brand' weight='bold'>{props.lineOne}</Text>
        <Text color='brand' weight='bold'>{props.lineTwo}</Text>
        {
            props.path === props.route ?
            <Box background='accent-2' height='7px' />
            :
            null
        }
    </Box>
}

const buttonFixTheme = {
    button: {
        extend: css`
        ${props => 'padding-top: 10px; padding-bottom: 10px; margin-top: 7px; margin-left: 5px' } 
        `
    }
};

const Header = (props) => { 
    const authorizedUser = useContext(AuthorizedUserContext) 
    const path = props.history.location.pathname;
    const history = props.history;
    return <Box
        background='transparent' 
        direction='row'
        flex={true}
        justify='end'
        margin={{ right: 'small'}}
   >
        <Box
            align="center" 
            alignContent='end' 
            background='transparent' 
            direction='row'
            justify='end'
        >
            <ResponsiveContext.Consumer>
            {size => {
                if (size === 'large') {
                return ( 
                    <Box direction='row'>
                        <Button label={<TwoLineSelectable history={history} path={path} route="/" lineOne="what's all" lineTwo="this, then?" />} margin='small' plain /> 
                        <Button label={<TwoLineSelectable history={history} path={path} route="/partners" lineOne="our partners" lineTwo="(coming soon)" />} margin='small' plain /> 
                        <Button label={<TwoLineSelectable history={history} path={path} route="/marketplace" lineOne="marketplace" lineTwo="(coming soon)" />} margin='small' plain />
                    </Box>
                )
                } else {
                    return ( 
                            <Menu
                                icon={<MenuIcon color="brand" size="medium" />} 
                                items={[
                                    { label: "what's all this then", onClick: () => history.push(ROUTES.LANDING) },
                                    { label: 'our partners (coming soon)', onClick: () => {} },
                                    { label: 'marketplace (coming soon)', onClick: () => {} },
                                ]}
                                margin={{ left: 'small', right: 'medium' }}
                            />
                    )
                }
            }}
            </ResponsiveContext.Consumer>
        </Box>
        <Box
            alignContent='around' 
            background='transparent' 
            direction='row'
            justify='end'
            responsive={false} 
        >
            <SignInOutButton />
            {
            authorizedUser && 
                <ConfigureFlopFlip defaultFlags={flags} adapter={adapter}>  
                  <ToggleFeature flag={'subscribe'}>
                    <PayPalSubscribeButton />
                  </ToggleFeature>
                </ConfigureFlopFlip>
            }
            {/*<Button fill={false} label={<ButtonLabel children='try for free'/>}  margin='xsmall' onClick={() => {}} primary={true} />
            <Button fill={false} label={<ButtonLabel children={<Text color='brand'>sign in</Text>}/>} margin='xsmall' onClick={() => {}} />*/}
        </Box>
    </Box>
}

export default withRouter(Header)
